<!-- A lot of ngIf cause first we have to display releated products and display zippy tabs only for carousel with products -->
@if( component ) {
@if(component.minibasketVersion) {
@for (section of sections; track $index) {
<basket-related-products class="block p-b-5"
                         [limit]="component.limit || 10"
                         [options]="{
                            engines: [{
                                id: 'manual',
                                options: {
                                    ids: section.ids
                                }
                            }]
                          }"
                         [acClickCode]="section.clickCode"
                         [listId]="component.id"
                         [listName]="section.title"
                         [title]="component.title">
</basket-related-products>
}
} @else {
<div class="center wrap-x"
     [hidden]="!printedSectionIndexes.length && !client.isCms"
     [class.ng-hide]="!printedSectionIndexes.length && !client.isCms">
    @if (sections.length ) {
    <h3 class="h1 p-t-5-s p-t-5-m"
        sizeClass="XL:h1, MS:h2"
        *iCms="'title' of component; skipEmpty: true"
        [scrollNavTarget]="'Related products' | translate"></h3>

    <p class="m-t-1 p1"
       *iCms="'subtitle' of component; skipEmpty: true"></p>

    <div class="col-12 underline"
         sizeClass="!S: flex flex-justify-center m-t-3"
         [hidden]="!hasManySections"
         [class.ng-hide]="!hasManySections">
        @for (section of sections; track $index) {
        <button [hidden]="!isSectionPrinted($index)"
                class="s1 product-carousel-tab m-t-2-s w-12-s"
                [class.cursor-pointer]="hasManySections"
                [toggle]="[groupName, $index]"
                [toggleClass]="'col-1 !col-12'">
            <span class="underline-s">{{section.title}}</span>
            @if(!$last) {
            <div *ifSize="'!S'"
                 class="vertical-separator m-r-3 m-l-3">
            </div>
            }
        </button>
        }
    </div>
    }

    @for (section of sections; track $index) {
    <div [hidden]="!isSectionPrinted($index)"
         [sizeClass]="'XL:m-l-6 m-r-6 m-t-8,SM:m-l m-r m-t-6'">
        <div [toggleClassBy]="[groupName, $index]"
             [toggleClass]="'!ng-hide'">

            <related-products class="block p-b-8"
                              [limit]="component.limit || 8"
                              [options]="{
                            engines: [{
                                id: 'manual',
                                options: {
                                    ids: section.ids
                                }
                            }]
                          }"
                              [acClickCode]="section.clickCode"
                              [listId]="component.id"
                              [listName]="section.title"
                              (isPrinted)="printSection($index, $event)">
            </related-products>
        </div>
    </div>
    }
</div>
}
}